<template>
  <div>
    <apexchart
      v-if="sortedEntries.length"
      type="bar"
      :height="Math.max(360, sortedEntries.length * 34 + 80)"
      :options="opts"
      :series="series"
    />
    <empty-state
      v-else
      icon="mdi-account-check-outline"
      :title="$t('no_data')"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "MealsTakenChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    agg() {
      const map = {};
      for (const item of this.orders) {
        if (!map[item.meal]) map[item.meal] = { ordered: 0, taken: 0 };
        map[item.meal].ordered += item.qty;
        map[item.meal].taken += item.taken;
      }
      return map;
    },
    sortedEntries() {
      return Object.entries(this.agg)
        .map(([meal, d]) => ({ meal, taken: d.taken, notTaken: d.ordered - d.taken }))
        .filter((e) => e.taken + e.notTaken > 0)
        .sort((a, b) => b.taken + b.notTaken - (a.taken + a.notTaken));
    },
    categories() {
      return this.sortedEntries.map((e) => e.meal);
    },
    series() {
      return [
        { name: this.$t("taken1"), data: this.sortedEntries.map((e) => e.taken) },
        { name: this.$t("ordered_not_taken"), data: this.sortedEntries.map((e) => e.notTaken) },
      ];
    },
    opts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
          },
          fontFamily: "Roboto, sans-serif",
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "70%" } },
        colors: ["#43A047", "#EF5350"],
        xaxis: { categories: this.categories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 240 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        dataLabels: { enabled: false },
        tooltip: { shared: true, intersect: false },
        fill: { opacity: 1 },
        grid: { borderColor: "#f1f1f1" },
        responsive: [
          {
            breakpoint: 600,
            options: {
              yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 130 } },
              xaxis: { labels: { style: { fontSize: "11px" } } },
              legend: { fontSize: "12px", itemMargin: { horizontal: 6 } },
              plotOptions: { bar: { barHeight: "60%" } },
            },
          },
        ],
      };
    },
  },
};
</script>
